import { activityStateEnum, activityTypeEnum } from '../enums';

const pastelGreen = '#8BC34A';

export const activityStateColors: Record<number, { background: string; text: string }> = {
    [activityStateEnum.ENTERED]: { background: 'purple', text: 'white' },
    [activityStateEnum.VALIDATED]: { background: 'green', text: 'white' },
    [activityStateEnum.SEMIVALIDATED]: { background: 'blue', text: 'white' },
    [activityStateEnum.VALIDATION]: { background: 'orange', text: 'black' },
    [activityStateEnum.REPORTFILLED]: { background: pastelGreen, text: 'black' },
    [activityStateEnum.REPORT]: { background: 'yellow', text: 'black' },
    [activityStateEnum.PLANNINGSENT]: { background: pastelGreen, text: 'black' },
    [activityStateEnum.PLANNING]: { background: 'yellow', text: 'black' },
    [activityStateEnum.NEEDSIMPORTED]: { background: '#CB22C1', text: 'white' },
    [activityStateEnum.NEEDSSENT]: { background: pastelGreen, text: 'black' },
    [activityStateEnum.NEEDSFILLED]: { background: 'yellow', text: 'black' },
    [activityStateEnum.NEEDS]: { background: 'yellow', text: 'black' },
};

export const getActivityStateColor = (state?: number): string => {
    return state !== undefined ? (activityStateColors[state]?.background ?? 'yellow') : 'yellow';
};
